/* eslint-disable func-names */
import NProgress from 'nprogress';
// import Swiper styles

const bannergenerator = document.querySelector('[data-js-module="o-bannergenerator"]');

const init = async () => {
  document.getElementById('tx_mllogogen_pi1_submitDownload').addEventListener('click', event => {
    event.preventDefault();
    const bannerForm = document.getElementById('bannerform');

    if (!bannerForm.checkValidity()) {
      if (bannerForm.reportValidity) {
        bannerForm.reportValidity();
      }
    } else {
      NProgress.start();
      bannerForm.submit();
    }
  });
};

if (bannergenerator) {
  init();
}
